import * as React from "react";
import HedgingModel from "./HedgingModel";
import ModelTitle from "../../../components/model/ModelTitle";
import ModelInfo from "../../../components/model/ModelInfo";
import {GAEventModels} from "../../../utils/SendGAEvent";
import ModelDescription from "../../../components/model/ModelDescription";
import Disclaimer from "../../../components/model/Disclaimer";
import TabPanel from "../../../components/model/TabPanel";

const OverviewSection = () => {
  return <div>
      <ModelTitle>Hedging Tool</ModelTitle>
      <ModelInfo model={GAEventModels.HEDGING_TOOL}/>
      <TabPanel
          modelName={GAEventModels.HEDGING_TOOL}
          modelDescription={<ModelDescription>Calculates and outputs relevant negatively correlated assets when given a ticker symbol.</ModelDescription>}
          content={<HedgingModel/>}
      />
      <Disclaimer/>
    </div>;
};

export default OverviewSection;


// WEBPACK FOOTER //
// ./src/routes/Dashboard/Hedging/HedgingSection.tsx